import { GENERATE_URL } from "@services/helpers/request";

export const GetSummary = (options) =>
  GENERATE_URL("/CrmDashboard/Summary", options);
export const GetTrends = (options) =>
  GENERATE_URL("/CrmDashboard/Trends", options);
export const GetReactions = (options) =>
  GENERATE_URL("/CrmDashboard/Reactions", options);
export const GetTagActivity = (options) =>
  GENERATE_URL("/CrmDashboard/TagActivity", options);
export const GetPlatformRegions = (options) =>
  GENERATE_URL("/CrmDashboard/PlatformRegions", options);
export const GetBrandRegions = (options) =>
  GENERATE_URL("/CrmDashboard/BrandRegions", options);

export default {
  GetSummary,
  GetTrends,
  GetReactions,
  GetTagActivity,
  GetPlatformRegions,
  GetBrandRegions,
};
